import { FC } from 'react';

import { ProductImage } from '@savgroup-front-common/core/atoms/ProductImage';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { ICONS_TYPE } from '@savgroup-front-common/types';
import useGetModelById from '@/hooks/useGetModelById';

import {
  $CardContentSmallThumbnail,
  $CardContentSmallThumbnailWrapper,
} from '../MultiProductInfoDescription.styles';

interface ModelsIconProps {
  modelId: string;
}

export const ModelsIcon: FC<ModelsIconProps> = ({ modelId }) => {
  const { model, isLoading } = useGetModelById({ modelId });

  if (isLoading) {
    return null;
  }

  return (
    <$CardContentSmallThumbnailWrapper>
      <$CardContentSmallThumbnail>
        <>
          {model?.pictureUrl ? (
            <ProductImage pictureUrl={model?.pictureUrl} title="pictureUrl" />
          ) : (
            <MyAccountIcon icon={ICONS_TYPE.BOX_ICON} />
          )}
        </>
      </$CardContentSmallThumbnail>
    </$CardContentSmallThumbnailWrapper>
  );
};

ModelsIcon.displayName = 'ModelsIcon';
